window.addEventListener("load", (event) => {
     let faqElement = document.querySelectorAll('.question-wrap-content');
     let elementHeight= '';
     let heightList = [];
     for(let i =0 ; i < faqElement.length; i++){
          elementHeight = faqElement[i].clientHeight;
          heightList.push(elementHeight);
     }
     let maxHeight = Math.max.apply(0, heightList) + 290;
     
     function mediaQuries(x) {
          const faqWrap = document.getElementById('section-faq-wrap');
          if (x.matches && faqWrap) { // If media query matches
               faqWrap.style.height= maxHeight + 'px';
               return;
          }
     }
     
     var x = window.matchMedia("(min-width: 1200px)");
     mediaQuries(x);
     x.addListener(mediaQuries);
});
